import React from "react";
import AppDialog from "../../common/AppDialog/AppDialog";
import PropTypes from "prop-types";

function UserModal({ open, onClose, state }) {
  console.log("state", state);
  function formatDigits(value) {
    // Check for null, undefined, or empty values
    if (!value || typeof value !== "string") {
      return "";
    }

    // Remove non-digit characters
    const digits = value.replace(/\D/g, "");

    // Return an empty string if there are no digits
    if (digits.length === 0) {
      return "";
    }

    // Format the string into groups separated by spaces
    return `+1 ${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(
      6
    )}`.trim();
  }
  return (
    <AppDialog
      open={open}
      onClose={() => {
        onClose(false);
      }}
      title="User Details"
      minHeight="auto"
      maxWidth="md"
    >
      <div>
        <div className="row mb-3">
          <div className="col-md-6 mb-3">
            <strong>User Name</strong>
            <p>{state?.username || "N/A"}</p>
          </div>
          <div className="col-md-4 mb-3">
            <strong>User Code</strong>
            <p>{state?.userCode || "N/A"}</p>
          </div>
          <div className="col-md-6 ">
            <strong>Email</strong>
            <p>{state?.email || "N/A"}</p>
          </div>
        </div>
      </div>

      <div>
        <div className="row mb-3">
          <div className="col-md-6 mb-3">
            <strong>Country</strong>
            <p>{state?.country || "N/A"}</p>
          </div>
          <div className="col-md-4 mb-3">
            <strong>Phone</strong>
            <p>{formatDigits(state?.phoneNumber) || "N/A"}</p>
          </div>
        </div>
      </div>
    </AppDialog>
  );
}

export default UserModal;

UserModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  state: PropTypes.any,
};
